var app = angular.module('directives.promoterScore');
app.directive('promoterScore', [
    'configs',
    '$translate',
    '$location',
    '$state',
    'Authentication',
    'PortalApi',
    'Locations',
    'Notification',
    function(configs, $translate, $location, $state, Authentication, PortalApi, Locations, Notification) {
        var tmplUrl;

        try {
            tmplUrl = require('../templates/'+$state.current.name.replace('pages.','')+'.html');//looking for template with moduleName
        }catch(e){
            tmplUrl = require('../templates/index.html')//if error, use default template
        }


        return {
            restrict: 'E',
            scope: {
                obj: '=',
            },
            template: tmplUrl,
            controller: [
                '$scope',
                '$state',
                '$location',
                'Authentication',
                'PortalApi',
                'Locations',
                'Notification',
                function($scope, $state, $location, Authentication, PortalApi, Locations, Notification) {
                    $scope.id = $scope.obj || $state.params.payment_id;
                    $scope.starInfo = {
                        stars: [1,2,3,4,5],
                        num: 5,
                        status: 0
                    };
                    $scope.promoterInfo = {
                        id: $scope.id,
                        score: 5,
                        comment: '',
                        location: Locations.location.id,
                        email: Authentication.user.email || '',
                    }
                    $scope.starScore = function(num) {
                        if (num > 0) {
                            $scope.starInfo.num = num;
                        } else {
                            $scope.starInfo.num = 0;
                        }
                    };

                    $scope.addScore = function () {
                        PortalApi.addScore($scope.promoterInfo).then(function(response) {
                            if (response.status == 'ok') {
                                $scope.starInfo.status = 1;
                            }
                        }, function(resolve) {
                            if (resolve.status = 'error') {
                                $scope.starInfo.num = 0;
                                $translate('ERRORS.UNKNOWN_ERROR').then(function (translation) {
                                    Notification.error({
                                        message: translation,
                                        delay: true
                                    });
                                });
                            };
                        });
                    };
                }
            ]
        }
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/promoterScore/directives/score.js
 ** module id = 213
 ** module chunks = 1
 **/